var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.8 9H7.2C4 9 2 11 2 14.2V16.79C2 20 4 22 7.2 22H16.79C19.99 22 21.99 20 21.99 16.8V14.2C22 11 20 9 16.8 9Z",
    fill: "#276E91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.88 5.56994L12.53 2.21994C12.24 1.92994 11.76 1.92994 11.47 2.21994L8.12 5.56994C7.83 5.85994 7.83 6.33994 8.12 6.62994C8.41 6.91994 8.89 6.91994 9.18 6.62994L11.25 4.55994V15.2499C11.25 15.6599 11.59 15.9999 12 15.9999C12.41 15.9999 12.75 15.6599 12.75 15.2499V4.55994L14.82 6.62994C14.97 6.77994 15.16 6.84994 15.35 6.84994C15.54 6.84994 15.73 6.77994 15.88 6.62994C16.18 6.33994 16.18 5.86994 15.88 5.56994Z",
    fill: "#276E91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImage);
export default __webpack_public_path__ + "static/media/uploadImage.9bda2fff1f4d81965ac3238858a01153.svg";
export { ForwardRef as ReactComponent };